import {
  BANK_PAYOUT_SUCCESS,
  BANK_PAYOUT_FAILED,
  BANK_PAYOUT_INVALID_REQUEST,
  BANK_PAYOUT_INVALID_CUSTID,
  BANK_PAYOUT_INVALID_WALLET_OWNER_ID,
  BANK_PAYOUT_INVALID_AMOUNT,
  BANK_PAYOUT_ACCOUNT_NOT_EXIST,
  BANK_PAYOUT_INSUFF_FUND,
  BANK_PAYOUT_INVALID_INTEGRATION,
  LOADING_BANK_PAYOUT,
  RESET_BANK_PAYOUT
} from "../types";

const initialState = {
  isLoading: false,
  success: false,
  failed: false,
  invalidRequest: false,
  invalidCustomerId: false,
  invalidWalletOwner: false,
  invalidAmount: false,
  accountNotExist: false,
  insufficientAmount: false,
  invalidIntegration: false,
  data: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_BANK_PAYOUT:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        invalidRequest: false,
        invalidCustomerId: false,
        invalidWalletOwner: false,
        invalidAmount: false,
        accountNotExist: false,
        insufficientAmount: false,
        invalidIntegration: false,
        data: {}
      };

    case BANK_PAYOUT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        invalidRequest: false,
        invalidCustomerId: false,
        invalidWalletOwner: false,
        invalidAmount: false,
        accountNotExist: false,
        insufficientAmount: false,
        invalidIntegration: false,
        data: action.payload
      };

    case BANK_PAYOUT_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        invalidRequest: false,
        invalidCustomerId: false,
        invalidWalletOwner: false,
        invalidAmount: false,
        accountNotExist: false,
        insufficientAmount: false,
        invalidIntegration: false,
        data: action.payload
      };

    case BANK_PAYOUT_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        invalidRequest: true,
        invalidCustomerId: false,
        invalidWalletOwner: false,
        invalidAmount: false,
        accountNotExist: false,
        insufficientAmount: false,
        invalidIntegration: false,
        data: action.payload
      };

    case BANK_PAYOUT_INVALID_CUSTID:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        invalidRequest: false,
        invalidCustomerId: true,
        invalidWalletOwner: false,
        invalidAmount: false,
        accountNotExist: false,
        insufficientAmount: false,
        invalidIntegration: false,
        data: action.payload
      };

    case BANK_PAYOUT_INVALID_WALLET_OWNER_ID:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        invalidRequest: false,
        invalidCustomerId: false,
        invalidWalletOwner: true,
        invalidAmount: false,
        accountNotExist: false,
        insufficientAmount: false,
        invalidIntegration: false,
        data: action.payload
      };

    case BANK_PAYOUT_INVALID_AMOUNT:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        invalidRequest: false,
        invalidCustomerId: false,
        invalidWalletOwner: false,
        invalidAmount: true,
        accountNotExist: false,
        insufficientAmount: false,
        invalidIntegration: false,
        data: action.payload
      };

    case BANK_PAYOUT_ACCOUNT_NOT_EXIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        invalidRequest: false,
        invalidCustomerId: false,
        invalidWalletOwner: false,
        invalidAmount: false,
        accountNotExist: true,
        insufficientAmount: false,
        invalidIntegration: false,
        data: action.payload
      };

    case BANK_PAYOUT_INSUFF_FUND:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        invalidRequest: false,
        invalidCustomerId: false,
        invalidWalletOwner: false,
        invalidAmount: false,
        accountNotExist: false,
        insufficientAmount: true,
        invalidIntegration: false,
        data: action.payload
      };

    case BANK_PAYOUT_INVALID_INTEGRATION:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        invalidRequest: false,
        invalidCustomerId: false,
        invalidWalletOwner: false,
        invalidAmount: false,
        accountNotExist: false,
        insufficientAmount: false,
        invalidIntegration: true,
        data: action.payload
      };

    case RESET_BANK_PAYOUT:
      return (state = initialState);

    default:
      return state;
  }
};
